import { formatEmptyString } from "@core/filters";

export const modificationValues = (oldValue: string | number | undefined, newValue: string | number) =>
  oldValue != null && newValue != null ? `${ oldValue }\u00A0 ➜ \u00A0${ newValue }` : newValue != null ? newValue : formatEmptyString();